import React from 'react';

import Overlay from '@sv-support-sdk/ui-components/src/components/Layout/Overlay';

import Modal from '../../../components/Layout/Modal';
import ContactUsForm from './components/ContactUsForm';

import { useAppDispatch } from '../../../store/hooks';
import modalActions from '../../../store/actions/modals';
import { CONTACT_US_MODAL } from '../../../constants/modals';
import { $l } from '../../../locales';
import useMobileDetect from '../../../hooks/useMobileDetect';

const ContactUsModal = () => {
  const dispatch = useAppDispatch();
  const isMobile = useMobileDetect();

  const closeModal = () => {
    dispatch(modalActions.closeModal(CONTACT_US_MODAL));
  };

  return (
    <Overlay align="right" zIndex="1501">
      <Modal
        type={isMobile ? 'mobile' : 'sidebar'}
        title={$l('CONTACT_US.TITLE')}
        onCloseClick={closeModal}
        align="center"
      >
        <ContactUsForm />
      </Modal>
    </Overlay>
  );
};

export default ContactUsModal;
